import { NavLink } from "react-router-dom";

/** Settings / Webhook log switcher shared by both ezyVet settings pages. */
export function EzyVetSettingsTabs() {
  const cls = ({ isActive }: { isActive: boolean }) => `tab ${isActive ? "active" : ""}`;
  return (
    <nav className="tabs" aria-label="ezyVet settings sections" style={{ marginTop: 16, marginBottom: 0 }}>
      <NavLink to="/settings/integrations/ezyvet" end className={cls}>
        Settings
      </NavLink>
      <NavLink to="/settings/integrations/ezyvet/logs" className={cls}>
        Webhook log
      </NavLink>
    </nav>
  );
}
